"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Checkbox = _interopRequireDefault(require("../Checkbox")),
    _Icon = _interopRequireDefault(require("../Icon"));

require("./_bulk-actions.scss");

function withSuffix(a, b) {
  return b ? "".concat(a, " ").concat(b) : a;
}

var hasInvalidPermissions = function hasInvalidPermissions(a, b) {
  return !!b && a.some(function (a) {
    return !(a.permissions && a.permissions.includes(b));
  });
};

function BulkActions(a) {
  var b = a.totalItems,
      c = a.selectedItems,
      d = a.actions,
      e = a.onSelectAll,
      f = a.onSelectAction,
      g = a.darkMode,
      h = a.suffix,
      i = a.selectedItemsData;
  if (!b) return null;
  var j = b === c;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("bulk-actions", {
      "bulk-actions--partial": !j && c,
      "bulk-actions--dark-mode": g
    })
  }, _react["default"].createElement(_Checkbox["default"], {
    checked: j,
    onChange: e
  }), !c || j ? _react["default"].createElement("button", {
    type: "button",
    className: "bulk-actions__select-label",
    onClick: e
  }, withSuffix("".concat(j ? "DESELECT" : "SELECT", " ALL"), h)) : null, c && !j ? _react["default"].createElement("p", {
    className: "bulk-actions__selected"
  }, _react["default"].createElement("span", {
    className: "bulk-actions__selected__number"
  }, c), _react["default"].createElement("span", null, withSuffix("SELECTED", h))) : null, c && d && d.length ? _react["default"].createElement("div", {
    className: "bulk-actions__actions"
  }, d.map(function (a) {
    var b = a.icon,
        c = a.action,
        d = a.requiredPermission,
        e = a.label,
        h = hasInvalidPermissions(i, d),
        j = g ? "regent" : "black";
    return "string" == typeof b ? _react["default"].createElement(_Icon["default"], {
      key: b,
      name: b,
      onClick: h ? void 0 : f && f(c) || c,
      color: g ? "white" : "nevada",
      size: 20,
      hoverColor: h ? void 0 : j,
      tooltipLabel: e,
      tooltipId: b
    }) : b;
  })) : null);
}

var _default = (0, _react.memo)(BulkActions);

exports["default"] = _default;